import { styled } from 'styles'

export const Box = styled('div', {})
